export const defaultState = {
    videoCallInitiated: false,
    instantConsultationId: null,
};

export default function videoCall(state = defaultState, action) {
    switch (action.type) {
        case 'INITIATE_VIDEO_CALL':
            return Object.assign({}, state, {
                videoCallInitiated: true,
                isInsta: action.payload && action.payload.isInsta && action.payload.isInsta == 1 ? 1 : 0,
                instantConsultationId: (action.payload && action.payload.isInsta == 1 && action.payload.instantConsultationId)
                    ? action.payload.instantConsultationId
                    : null,
            });
        case 'END_VIDEO_CALL':
            return Object.assign({}, state, {
                videoCallInitiated: false,
                instantConsultationId: null,
            });
        default:
            return state;
    }
}
